var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListBtnMachinary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10,
    y: -10,
    width: 56,
    height: 56
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_21207_90771_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 10
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -11.25,
    y: -11.25,
    width: 58.5,
    height: 58.5
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5.62px)",
      clipPath: "url(#bgblur_1_21207_90771_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 11.25
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#232630"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0994 11.6685C18.6781 11.376 19.4672 11.4247 20.3616 11.8636C22.0976 12.79 23.5181 15.0816 23.5181 16.9345C23.5181 17.8609 23.1498 18.5435 22.5711 18.8361L21.2559 19.5675C21.8346 19.2749 22.2029 18.5923 22.2029 17.6659C22.2029 15.813 20.7824 13.5214 19.0463 12.5949C18.152 12.1074 17.3629 12.0586 16.7842 12.3999L18.0994 11.6685Z",
    fill: "url(#paint0_linear_21207_90771)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8369 14.2528C15.8369 16.1056 17.2573 18.3973 18.9934 19.3237C19.8878 19.8113 20.6769 19.8113 21.2556 19.5187C21.8343 19.2262 22.2026 18.5435 22.2026 17.6171C22.2026 15.7643 20.7821 13.4726 19.046 12.5462C18.1517 12.0586 17.3626 12.0099 16.7839 12.3512C16.2052 12.6925 15.8369 13.3263 15.8369 14.2528Z",
    fill: "#090707"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0469 14.8868C17.0469 16.057 17.9412 17.5198 19.046 18.1049C20.1508 18.69 21.0451 18.2024 21.0451 17.0322C21.0451 15.862 20.1508 14.3992 19.046 13.8141C17.9412 13.229 17.0469 13.7166 17.0469 14.8868Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9414 15.3742C17.9414 16.0081 18.4149 16.7882 18.9936 17.0808C19.5723 17.4221 20.0458 17.1295 20.0458 16.4956C20.0458 15.8618 19.5723 15.0816 18.9936 14.7891C18.4149 14.4965 17.9414 14.7403 17.9414 15.3742Z",
    fill: "#4C4C4C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.833 19.0986L25.1151 18.4167C26.2433 19.0077 27.1663 20.4167 27.1663 21.5986C27.1663 22.1895 26.9612 22.5986 26.551 22.7804L25.2689 23.4167C25.6279 23.2349 25.8843 22.8258 25.8843 22.2349C25.8843 21.0986 24.9612 19.6895 23.833 19.0986Z",
    fill: "url(#paint1_linear_21207_90771)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4157 18.6594L24.1767 19.3334C23.6316 19.0638 23.136 19.0189 22.7891 19.1986L24.028 18.5246C24.3749 18.3449 24.8705 18.3898 25.4157 18.6594Z",
    fill: "#07161C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19.8938C23 21.2461 23.8549 22.8584 24.8998 23.5345C25.4222 23.8465 25.8971 23.8985 26.2296 23.6905C26.562 23.4825 26.7995 23.0144 26.7995 22.3383C26.7995 20.986 25.9446 19.3737 24.8998 18.6976C24.3773 18.3855 23.9024 18.3335 23.5699 18.5416C23.19 18.7496 23 19.2177 23 19.8938Z",
    fill: "#090707"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7207 21.3099C22.7207 22.1421 23.2431 23.1823 23.908 23.5983C24.573 24.0144 25.0954 23.7024 25.0954 22.8182C25.0954 21.934 24.573 20.9459 23.908 20.5298C23.2431 20.1137 22.7207 20.4258 22.7207 21.3099Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2432 21.6217C23.2432 22.0898 23.5281 22.6099 23.9081 22.8699C24.288 23.078 24.573 22.9219 24.573 22.4539C24.573 21.9858 24.288 21.4657 23.9081 21.2056C23.5281 20.9976 23.2432 21.2056 23.2432 21.6217Z",
    fill: "#969696"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1016 11.8312L19.3681 11.051C21.5465 12.3513 23.3196 15.4718 23.3196 18.0723L22.0024 18.8524C22.0024 16.304 20.2799 13.1314 18.1016 11.8312Z",
    fill: "#009C17"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3145 11.5711L16.581 10.7909C17.3409 10.3748 18.3034 10.4789 19.3673 11.051L18.1008 11.8311C17.0369 11.259 16.0237 11.155 15.3145 11.5711Z",
    fill: "#F3F3F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0021 18.8525L21.3435 18.4885C21.3435 16.3561 19.8744 13.7556 18.0506 12.6634C17.1894 12.1433 16.3281 12.0913 15.7202 12.4033C15.6696 12.4033 15.6696 12.4554 15.6189 12.4554L15.1123 11.6232C15.163 11.5712 15.2136 11.5712 15.2136 11.5712C15.9735 11.1551 16.9361 11.2591 17.9999 11.8312C20.2796 13.1315 22.0021 16.3041 22.0021 18.8525Z",
    fill: "#F3F3F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8327 21.75L12.166 18.1179L13.1685 11.75L17.9304 14.3915L18.8327 21.75Z",
    fill: "#3E3E3E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8623 12L17.5361 14.4102L18.4632 22.0833L22.7894 19.7224L21.8623 12Z",
    fill: "#3E3E3E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.5338L21.222 12.6667L21.5022 15.2164L18.2335 17.1667L18 14.5338Z",
    fill: "#9DC5C8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2486 9.70338C17.1963 9.68008 17.1365 9.68031 17.0844 9.70399L12.9584 11.5794C12.8064 11.6486 12.801 11.8626 12.9495 11.9392L17.6531 14.3669C17.7133 14.398 17.7852 14.3965 17.844 14.3629L21.8236 12.0901C21.9659 12.0088 21.9555 11.8004 21.8058 11.7337L17.2486 9.70338Z",
    fill: "#019417"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8234 11.0961C17.555 10.9815 17.2516 10.9808 16.9826 11.0941C16.1103 11.4618 16.1033 12.6956 16.9715 13.0731L17.3344 13.2309C17.6072 13.3495 17.9169 13.3501 18.1901 13.2325C19.0603 12.8581 19.0587 11.6236 18.1874 11.2515L17.8234 11.0961Z",
    fill: "#FACD00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5359 19.3334C16.8447 17.5483 15.6005 15.8115 14.1259 14.9431C13.8033 14.7501 13.4808 14.6053 13.1582 14.5089L13.3425 12.9167L17.1212 15.1843L17.5359 19.3334Z",
    fill: "#7E9FA2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0955 16.1349C11.6742 15.8229 12.4633 15.8749 13.3577 16.343C15.0937 17.3311 16.5142 19.7756 16.5142 21.7519C16.5142 22.7401 16.1459 23.4683 15.5672 23.7803L14.252 24.5084C14.8307 24.1964 15.199 23.4683 15.199 22.4801C15.199 20.5037 13.7785 18.0593 12.0424 17.0711C11.1481 16.551 10.359 16.499 9.78027 16.8631L11.0955 16.1349Z",
    fill: "url(#paint2_linear_21207_90771)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83301 18.8915C8.83301 20.8679 10.2534 23.3123 11.9895 24.3005C12.8839 24.8206 13.673 24.8206 14.2517 24.5085C14.8304 24.1965 15.1986 23.4684 15.1986 22.4802C15.1986 20.5038 13.7782 18.0594 12.0421 17.0712C11.1478 16.5511 10.3587 16.4991 9.77996 16.8632C9.20127 17.1752 8.83301 17.9033 8.83301 18.8915Z",
    fill: "#090707"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99023 19.5676C9.99023 20.8158 10.8846 22.3761 11.9894 23.0002C13.0941 23.6243 13.9885 23.1042 13.9885 21.856C13.9885 20.6078 13.0941 19.0475 11.9894 18.4234C10.8846 17.7993 9.99023 18.3194 9.99023 19.5676Z",
    fill: "#FACD00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 20.0875C10.9375 20.7637 11.411 21.5958 11.9897 21.9599C12.5684 22.324 13.0418 22.0119 13.0418 21.3358C13.0418 20.6597 12.5684 19.8275 11.9897 19.5154C11.411 19.1514 10.9375 19.4114 10.9375 20.0875Z",
    fill: "#CBAC06"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3972 22.3759L17.8906 17.9031L21.5382 20.0875C21.5382 20.0875 22.8553 21.6998 22.5514 24.8203C20.4743 23.6241 18.3972 22.3759 18.3972 22.3759Z",
    fill: "#017713"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0532 19.4614C18.0115 19.0932 17.8906 17.9031 17.8906 17.9031L21.5832 20.0833C21.5832 20.0833 22.1913 20.7493 22.4999 22.0455C19.8886 20.5064 18.5903 19.7721 18.0532 19.4614Z",
    fill: "#FACD00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9831 18.1113L21.5889 20.0877C21.5889 20.0877 22.906 21.7 22.6021 24.8205L25.9963 22.7922C26.3003 19.7236 24.9831 18.1113 24.9831 18.1113Z",
    fill: "#009C17"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3356 15.9268L17.9414 17.9551L21.5889 20.0875L24.9832 18.1112L21.3356 15.9268Z",
    fill: "#019417"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4521 14.4057C11.212 13.9896 12.1745 14.0936 13.2384 14.6657C15.4167 15.9659 17.1898 19.0865 17.1898 21.687L15.9233 22.4671C15.9233 19.8667 14.1502 16.7461 11.9719 15.4459C10.908 14.8217 9.94545 14.7177 9.18555 15.1858L10.4521 14.4057Z",
    fill: "#009C17"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.923 22.467L15.2644 22.051C15.2644 19.9186 13.7953 17.3181 11.9715 16.2259C11.1103 15.7058 10.249 15.6538 9.64112 15.9658C9.59046 15.9658 9.59046 16.0179 9.5398 16.0179L9.0332 15.1857C9.08386 15.1337 9.13452 15.1337 9.13452 15.1337C9.89443 14.7176 10.857 14.8216 11.9208 15.3937C14.1499 16.746 15.923 19.9186 15.923 22.467Z",
    fill: "#019417"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5879 21.2941C19.9174 21.1056 20.3882 21.1056 20.9059 21.4355C21.9415 22.0482 22.7888 23.5092 22.7888 24.7345C22.7888 25.3472 22.6005 25.7713 22.224 25.9598L21.0472 26.6667C21.3767 26.4782 21.612 26.0541 21.612 25.4414C21.612 24.2161 20.7647 22.7551 19.7291 22.1424C19.2114 21.8597 18.7406 21.8125 18.4111 22.001L19.5879 21.2941Z",
    fill: "url(#paint3_linear_21207_90771)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.118C18 24.3704 18.9375 25.8637 20.0833 26.4899C20.6562 26.7789 21.1771 26.8271 21.5417 26.6344C21.9062 26.4417 22.1667 26.0082 22.1667 25.382C22.1667 24.1296 21.2292 22.6363 20.0833 22.0101C19.5104 21.7211 18.9896 21.6729 18.625 21.8656C18.2604 22.0583 18 22.4918 18 23.118Z",
    fill: "#090707"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.833 23.5179C18.833 24.3259 19.383 25.336 20.083 25.74C20.783 26.144 21.333 25.841 21.333 24.9824C21.333 24.1744 20.783 23.1644 20.083 22.7604C19.383 22.3563 18.833 22.6593 18.833 23.5179Z",
    fill: "#FACD00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.666 23.8685C19.666 24.2933 19.9339 24.7653 20.291 25.0014C20.6482 25.1902 20.916 25.0486 20.916 24.6237C20.916 24.1989 20.6482 23.7268 20.291 23.4908C19.9339 23.302 19.666 23.4908 19.666 23.8685Z",
    fill: "#CBAC06"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5402 23.3316V22.3955C22.5402 22.2785 22.6542 22.1029 22.7682 22.0444L23.851 21.4008C23.908 21.3423 23.965 21.3423 24.022 21.4008L23.6801 21.1667C23.6231 21.1667 23.5661 21.1667 23.5091 21.1667L22.4262 21.8104C22.3122 21.8689 22.1982 22.0444 22.1982 22.1614V23.0976C22.1982 23.1561 22.1982 23.2146 22.2552 23.2146L22.5402 23.3902C22.5402 23.4487 22.5402 23.3902 22.5402 23.3316Z",
    fill: "url(#paint4_linear_21207_90771)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8509 21.3422C23.9079 21.2837 23.9649 21.2837 24.0218 21.3422C24.0788 21.3422 24.0788 21.4007 24.0788 21.4592V22.3954C24.0788 22.5124 23.9649 22.688 23.8509 22.7465L22.768 23.3901C22.711 23.4486 22.654 23.4486 22.597 23.3901C22.54 23.3901 22.54 23.3316 22.54 23.2731V22.3369C22.54 22.2199 22.654 22.0444 22.768 21.9858L23.8509 21.3422Z",
    fill: "#E7E7E7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0525 21.6987V20.7625C25.0525 20.6455 25.1665 20.4699 25.2805 20.4114L26.3634 19.7678C26.4204 19.7093 26.4774 19.7093 26.5344 19.7678L26.2494 19.5923C26.1924 19.5923 26.1354 19.5923 26.0784 19.5923L24.9955 20.2359C24.8816 20.2944 24.7676 20.4699 24.7676 20.587V21.5231C24.7676 21.5816 24.7676 21.6402 24.8246 21.6402L25.1095 21.8157C25.0525 21.8157 25.0525 21.7572 25.0525 21.6987Z",
    fill: "url(#paint5_linear_21207_90771)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3059 19.7678C26.3629 19.7092 26.4199 19.7092 26.4769 19.7678C26.5339 19.7678 26.5339 19.8263 26.5339 19.8848V20.821C26.5339 20.938 26.4199 21.1135 26.3059 21.172L25.2231 21.8156C25.1661 21.8741 25.1091 21.8741 25.0521 21.8156C24.9951 21.8156 24.9951 21.7571 24.9951 21.6986V20.7624C24.9951 20.6454 25.1091 20.4699 25.2231 20.4114L26.3059 19.7678Z",
    fill: "#E7E7E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_21207_90771_clip_path",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_21207_90771_clip_path",
    transform: "translate(11.25 11.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21207_90771",
    x1: 26.0325,
    y1: 15.9109,
    x2: 20.4631,
    y2: 9.70603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    stopColor: "#2A2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4994,
    stopColor: "#2C292A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6994,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9043,
    stopColor: "#3D3B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21207_90771",
    x1: 27.929,
    y1: 20.8705,
    x2: 24.4559,
    y2: 18.5007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532705,
    stopColor: "#2C292A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6994,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9043,
    stopColor: "#3D3B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21207_90771",
    x1: 19.0268,
    y1: 20.6681,
    x2: 13.086,
    y2: 14.3881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    stopColor: "#2A2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4994,
    stopColor: "#2C292A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6994,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9043,
    stopColor: "#3D3B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21207_90771",
    x1: 24.1796,
    y1: 24.1841,
    x2: 20.6606,
    y2: 20.3181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    stopColor: "#2A2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4994,
    stopColor: "#2C292A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6994,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9043,
    stopColor: "#3D3B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_21207_90771",
    x1: 22.5968,
    y1: 20.2837,
    x2: 20.9901,
    y2: 22.1646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    stopColor: "#2A2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4994,
    stopColor: "#2C292A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6994,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9043,
    stopColor: "#3D3B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_21207_90771",
    x1: 25.1072,
    y1: 18.6638,
    x2: 23.4689,
    y2: 20.5032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    stopColor: "#2A2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4994,
    stopColor: "#2C292A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6994,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9043,
    stopColor: "#3D3B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBtnMachinary);
export default __webpack_public_path__ + "static/media/list-btn-machinary.7e6304ef335a3dc56d69c79e8aa101c2.svg";
export { ForwardRef as ReactComponent };